import axios from 'axios'
import {
  BancoMonedasModel,
  CuentasHeo,
  DatoscuentabModel,
  DatosTipoDestinatarioModel,
  ListaProdFInancieros,
  MessageModel,
  MetodosPagoModel,
  Model_Mensaje,
  ModelComisionesRangos,
  ModelComisionesRangosDelete,
  ModelService_ComisionesRangos,
  ModelService_Filter,
  ModelService_Filter2,
  ModelService_Moneda,
  ModelService_StatusRemesas,
  ModelService_TcPre,
  ModelService_TcUltimos10,
  ModelService_TipoDeCambio,
  ModelService_TipoDeCambioTable,
  ModelTipoCambio,
  ModelTipoCambioDelete,
  RemesasCabeceraModel,
  RemesasCabeceraModelResponse,
  ResumenRemesasResponseModel,
  ValidarCuponResponseModel,
  WizardCuestionarioModel,
} from './_models'
import {RecuperarModel} from '../../auth'

const API_URL = process.env.REACT_APP_API_URL2

export const URL_TIPO_CAMBIO = `${API_URL}/Tipo_Cambio_del_dia`
export const URL_COMISIONES_RANGO = `${API_URL}/Comisiones_Rangos`
export const URL_MONEDA = `${API_URL}/Cat_Monedas`
export const URL_STATUSREMESAS = `${API_URL}/RemesasStatusOperaciones`
export const URL_REMESASSTATUS = `${API_URL}/RemesasStatus`
export const URL_TC_ULTIMOS10 = `${API_URL}/v_TC_ultimos_10_dias`
export const URL_TC_PRE = `${API_URL}/V_TC_PRE`

// TIPO DE CAMBIO
export function findAllTipoCambio() {
  return axios.get<ModelService_TipoDeCambio>(`${URL_TIPO_CAMBIO}/Lista
`)
}

export function readAllTipoCambioBody(value: ModelService_Filter) {
  return axios.post<ModelService_TipoDeCambio>(`${URL_TIPO_CAMBIO}/Read_All`, value)
}

export function readAllTipoCambioTable(value: ModelService_Filter2) {
  return axios.post<ModelService_TipoDeCambioTable>(`${URL_TIPO_CAMBIO}/Read_All`, value)
}

export function updateTipoCambio(data: ModelTipoCambio[]) {
  return axios.post<Model_Mensaje>(`${URL_TIPO_CAMBIO}/Update`, data)
}

export function deleteTipoCambioAll(data: ModelTipoCambioDelete) {
  return axios.post<Model_Mensaje>(`${URL_TIPO_CAMBIO}/DeleteAll`, data)
}

// MONEDA
export function readAllMonedaBody(value: ModelService_Filter) {
  return axios.post<ModelService_Moneda>(`${URL_MONEDA}/Read_All`, value)
}

//STATUS REMESAS
export function readAllStatusRemesas(value: ModelService_Filter2) {
  return axios.post<ModelService_StatusRemesas>(`${URL_STATUSREMESAS}/Read_All`, value)
}

//REMESAS STATUS
export function updateStatusRemesas(id_remesasOper: number, id_estatus_remesas: string) {
  return axios.post<MessageModel>(`${URL_REMESASSTATUS}/UpdateStatusRemesa`, {
    id_remesasOper,
    id_estatus_remesas,
  })
}

// COMISIONES RANGO
export function findAllComisionesRango() {
  return axios.get<ModelService_ComisionesRangos>(`${URL_COMISIONES_RANGO}/Lista
`)
}

export function readAllComisionesRangoBody(value: ModelService_Filter) {
  return axios.post<ModelService_ComisionesRangos>(`${URL_COMISIONES_RANGO}/Read_All`, value)
}

export function updateComisionesRango(data: ModelComisionesRangos[]) {
  return axios.post<Model_Mensaje>(`${URL_COMISIONES_RANGO}/Update`, data)
}

export function deleteComisionesRangoAll(data: ModelComisionesRangosDelete) {
  return axios.post<Model_Mensaje>(`${URL_COMISIONES_RANGO}/DeleteAll`, data)
}

//
export const WIZARDQUESTIONS_URL = `${API_URL}/PreferenciasPreguntas/Usuarios_Read_All`
export const GETTIPOSDESTINATARIOS_URL = `${API_URL}/Destinatario_Tipo/Activos`
export const ENVIARCORREOREMESA_URL = `${API_URL}/Correo/EnviarCorreo`
export const CREATEREMESA_URL = `${API_URL}/RemesasOperaciones/CreateRemesas`
export const VALIDARCUPON_URL = `${API_URL}/Cat_Cod_Promocional/ValidarCupon`
export const WIZARDGETCUENTASHEO_URL = `${API_URL}/CtasBancariasHeo_CanalBanco/ListaByIdProdFinaciero`
export const RESUMENREMESAS_URL = `${API_URL}/RemesasOperaciones/Operaciones_Pais_Mes_2`
export const GETCUENTASBANCARIASWIZARD_URL = `${API_URL}/CtasBancarias_OrigDest/UnicasByUsuario`
export const METODOSPAGOS_URL = `${API_URL}/Cat_Canales/Read_All_Canales`
export const GETCUENTASBANCARIASDESTINO_URL = `${API_URL}/CtasBancarias_OrigDest/ByUsuarioCanal`
export const GETBOMONEDASCTASBAN_URL = `${API_URL}/cat_Prod_Financ_Banco/monedas`
export const CREATECUENTABANCARIA_URL = `${API_URL}/CtasBancarias_OrigDest/Create`
export const DELETECUENTABANCARIA_URL = `${API_URL}/CtasBancarias_OrigDest/Delete`
export const UPDATECUENTABANCARIA_URL = `${API_URL}/CtasBancarias_OrigDest/Update`

export function getCuestionario(usuario: number, Language: string) {
  return axios.post<WizardCuestionarioModel>(WIZARDQUESTIONS_URL, {
    usuario,
    Language,
  })
}

export function getTiposDestinatarios() {
  return axios.post<DatosTipoDestinatarioModel>(GETTIPOSDESTINATARIOS_URL)
}

export function EnviarCorreoRemesas(id_remesasOper: number) {
  return axios.post<MessageModel>(`${ENVIARCORREOREMESA_URL}?id_remesasOper=${id_remesasOper}`)
}

export function postCreateRemesa(data: RemesasCabeceraModel | undefined) {
  return axios.post<RemesasCabeceraModelResponse>(CREATEREMESA_URL, data)
}

export function validarCupon(cupon_Codigo: string, aplicar: boolean) {
  return axios.post<ValidarCuponResponseModel>(VALIDARCUPON_URL, {
    cupon_Codigo,
    aplicar,
  })
}

export function getCuentasHeo(lista: ListaProdFInancieros | undefined) {
  return axios.post<CuentasHeo>(WIZARDGETCUENTASHEO_URL, lista)
}

export function getResumenRemesas(idUsuario: number, pais: string = '') {
  return axios.post<ResumenRemesasResponseModel>(RESUMENREMESAS_URL, {
    idUsuario,
    pais,
  })
}

export function getCuentasBancariasWizard(id: number | undefined, lang: string) {
  return axios.post<DatoscuentabModel>(GETCUENTASBANCARIASWIZARD_URL, {
    id,
    lang,
  })
}

export function getmetodosEnvioRecepcion(tipoMetodo: string, isoPais: string) {
  return axios.post<MetodosPagoModel>(METODOSPAGOS_URL, {
    tipo: tipoMetodo,
    pais: isoPais,
  })
}

export function getCuentasBancariasDestinoModal(
  id: number,
  lang: string,
  canal: number,
  moneda: string,
  idBanco: number,
  iso2pais: string
) {
  return axios.post<DatoscuentabModel>(GETCUENTASBANCARIASDESTINO_URL, {
    id,
    lang,
    id_canal: canal,
    moneda,
    idBanco,
    iso2pais,
  })
}

export function getMonedasCtasBan(id_tipo_prod_financ: number, idBanco: number) {
  return axios.post<BancoMonedasModel>(GETBOMONEDASCTASBAN_URL, {
    id_tipo_prod_financ,
    idBanco,
  })
}

export function createCuentaBancaria(
  idusuario: number | undefined,
  id_prod_financieros: number,
  cci: string | null,
  nro_Cta: string | null,
  titular_Cta: string | null,
  lang: string,
  celular_destinatario: string | null,
  correo_destinatario: string | null,
  iban: string | null,
  clabe: string | null,
  cedula: string | null,
  id_tipo_destinatario: number | null,
  tipoDocumento: number | null,
  nroDocumento: string | null,
  nacionalidadBenef: string | null,
  cod_Envio: string | null,
  nro_Tarjeta: string | null
) {
  return axios.post<RecuperarModel>(CREATECUENTABANCARIA_URL, {
    idusuario,
    id_prod_financieros,
    cci,
    nro_Cta,
    titular_Cta,
    lang,
    celular_destinatario,
    correo_destinatario,
    iban,
    clabe,
    cedula,
    id_tipo_destinatario,
    tipoDocumento,
    nroDocumento,
    nacionalidadBenef,
    cod_Envio,
    nro_Tarjeta,
  })
}

export function deleteCuentaBancaria(id_cb: number, lang: string) {
  return axios.post<RecuperarModel>(DELETECUENTABANCARIA_URL, {
    id_cb,
    lang,
  })
}

export function updateCuentaBancaria(
  id_cb: number,
  idusuario: number | undefined,
  idBanco: number,
  cci: string | null,
  nro_Cta: string | null,
  titular_Cta: string | null,
  lang: string,
  celular_destinatario: string | null,
  correo_destinatario: string | null,
  iban: string | null,
  clabe: string | null,
  cedula: string | null,
  id_tipo_destinatario: number | null,
  tipoDocumento: number | null,
  nroDocumento: string | null,
  nacionalidadBenef: string | null,
  id_prod_financieros: number,
  cod_Envio: string | null,
  nro_Tarjeta: string | null
) {
  return axios.post<RecuperarModel>(`${UPDATECUENTABANCARIA_URL}?id=${id_cb}`, {
    idusuario,
    idBanco,
    cci,
    nro_Cta,
    titular_Cta,
    lang,
    celular_destinatario,
    correo_destinatario,
    iban,
    clabe,
    cedula,
    id_tipo_destinatario,
    tipoDocumento,
    nroDocumento,
    nacionalidadBenef,
    id_prod_financieros,
    cod_Envio,
    nro_Tarjeta,
  })
}

//URL_TC_ULTIMOS10
export function findAllUltimo10Dias(value: ModelService_Filter2) {
  return axios.post<ModelService_TcUltimos10>(`${URL_TC_ULTIMOS10}/Read_All`, value)
}

//URL_TC_PRE
export function findAllTcPre(paisO: string, fecha: string) {
  return axios.post<ModelService_TcPre>(`${URL_TC_PRE}/Read_All`, {
    paisO,
    fecha,
  })
}
